import React from 'react';
import { Link } from 'react-router-dom';
import api from '../../api';

interface CustomProps {
  itemPosition?: number;
  route?: string;
  defaultValue?: string;
  value?: string | number | any[] | any;
  separationChar?: string;
  noLink?: boolean;
  record?: {
    _id: string;
    frontName: string;
    isFrontApproved: boolean;
    frontUrl: string;
    frontType: string;
    backName: string;
    isBackApproved: boolean;
    backUrl: string;
    backType: string;
  };
}
const Component: React.SFC<CustomProps> = (props) => {
  const { route, record, defaultValue } = props;
  let { value } = props;

  if (Array.isArray(props.value)) {
    for (let x = 0; x < value.length; x += 1) {
      value[x] = value[x].charAt(0).toUpperCase() + value[x].substr(1);
    }
    return value.join(` ${props.separationChar ? props.separationChar : '|'} `);
  }
  if (typeof value === 'string') {
    value = value.charAt(0).toUpperCase() + value.substr(1);
  }
  if (!value && defaultValue) {
    value = defaultValue;
  }

  async function downloadFile(file: string) {
    const response = await api.media.getSignedDocumentUrl(file);
    if (response.data) {
      setTimeout(() => {
        const fileResponse = {
          file: response.data,
        };
        window.open(fileResponse.file);
      }, 100);
    }
  }

  return props.itemPosition === 0 && !props.noLink ? (
    <Link
      className="CrudTextField table-tbody__item--bold"
      to={`/${route}/${(record && record._id) || ''}`}
    >
      <span className="icon-document">
        <span className="path1"></span>
        <span className="path2"></span>
        <span className="path3"></span>
        <span className="path4"></span>
        <span className="path5"></span>
      </span>
      {value}
    </Link>
  ) : (
    <>
      <div className="CrudTextField">
        <span className="icon-document">
          <span className="path1"></span>
          <span className="path2"></span>
          <span className="path3"></span>
          <span className="path4"></span>
          <span className="path5"></span>
        </span>
        {value}
      </div>
      {record && record.frontName && record.isFrontApproved && (
        <div className="pt-2">
          <button
            className="link-button"
            onClick={(e) => {
              downloadFile(record.frontUrl);
            }}
          >
            {record.frontType === 'pdf' ? (
              <span className="icon-pdf">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
              </span>
            ) : (
              <i className="icon-print"></i>
            )}
            {record.frontName}
          </button>
        </div>
      )}

      {record && record.backName && record.isBackApproved && (
        <div className="pt-2">
          <button
            className="link-button"
            onClick={(e) => {
              downloadFile(record.backUrl);
            }}
          >
            {record.backType === 'pdf' ? (
              <span className="icon-pdf">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
              </span>
            ) : (
              <i className="icon-print"></i>
            )}
            {record.backName}
          </button>
        </div>
      )}
    </>
  );
};

Component.defaultProps = {
  itemPosition: 1,
};

export default Component;
